import React from 'react';
import { Menu } from 'antd';
import { Link } from 'react-router-dom';

function NewTabMenuItem(to, itemName, hidden) {
  return (
    <Menu.Item key={to} onClick={null} hidden={hidden}>
      <Link to={to} target="_blank">
        {itemName}
      </Link>
    </Menu.Item>
  );
}

export default NewTabMenuItem;
